module.exports = __webpack_public_path__ + "img/logo.a5f4c2a7.png";